export const state = () => ({
    settings: { phone: '', phone1: '', credit_percent: '', coordinates: '' },
    isNight: false,
})

export const getters = {
    settings: (state) => {
        return state.settings
    },
    isNight: (state) => {
        return state.isNight
    }
}
export const mutations = {
    SET_SETTINGS(state, data) {
        state.settings = { ...state.settings, ...(data || {}) }
        state.settings.phone = String(state.settings.phone || state.settings.contact_phone || '')
        state.settings.credit_percent = String(state.settings.credit_percent || '')
    },
    SET_NIGHT(state, data) {
        state.isNight = data
    }
}
